import React from 'react'
import clsx from 'clsx'
import styles from './TextArea.module.sass'

export enum Resize {
    NONE = 'none',
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
    BOTH = 'both',
}

export interface FieldProps {
    className?: string,
    value?: string | number | null,
    placeholder?: string,
    onChange?: (value: string) => void,
    resize?: Resize,
    block?: boolean,
}

const TextArea: React.FunctionComponent<FieldProps> = (props) => {
    return <textarea
        className={clsx(
            props.className,
            styles.textArea,
            { [styles.block]: props.block }
        )}
        style={{
            resize: props.resize || Resize.NONE,
        }}
        placeholder={props.placeholder || ''}
        value={props.value || ''}
        onChange={({ currentTarget }) => props.onChange?.(currentTarget.value)}
    />
}

export default TextArea
